import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className={`menu ${isOpen ? 'is-open' : ''}`}>
      <div className="menu-brand">
        <Link to="/" onClick={closeMenu}><span>TAVERNIX</span></Link>
      </div>

      <button
        type="button"
        className="menu-toggle"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        aria-label="Toggle navigation"
      >
        <span className="menu-toggle__label">{isOpen ? 'CLOSE' : 'MENU'}</span>
        <span className="menu-toggle__glyph" aria-hidden="true">{isOpen ? '[-]' : '[+]'}</span>
      </button>

      <div className={`menu-links ${isOpen ? 'open' : ''}`}>
        <Link to="/developments" onClick={closeMenu}><span>DEVELOPMENTS</span></Link>
        <Link to="/services" onClick={closeMenu}><span>SERVICES</span></Link>
      </div>
    </nav>
  );
};

export default Menu;
